<template>
    <section id="tech" class="tech">
        <div class="container">
            <div class="tech-content" v-scrollanimation>
                <div class="row" style="align-items: center;margin-top: 20px;">
                    <div class="col-lg-6 left">
                        <div v-scrollanimation>
                            <h2 class="main-title">
                                {{ $t('tech.main_title') }}
                            </h2>
                            <div class="tech-disc">
                                {{ $t('tech.title') }}
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 right">
                        <div class="grid-container tect-icons" v-scrollanimation>
                            <div class="grid-item">
                                <img src="../assets/img/tech icons/laravel.webp" id="laravel" alt="laravel">
                                <b-tooltip target="laravel" custom-class="laravel">Laravel</b-tooltip>
                            </div>
                            <div class="grid-item">
                                <img src="../assets/img/tech icons/flutter.webp" class="flutter" id="flutter" alt="flutter">
                                <b-tooltip target="flutter" custom-class="flutter2">Flutter</b-tooltip>
                            </div>
                            <div class="grid-item">
                                <img src="../assets/img/tech icons/mysql.webp" id="mysql" alt="mysql">
                                <b-tooltip target="mysql" custom-class="mysql">MySql</b-tooltip>
                            </div>
                            <div class="grid-item">
                                <img src="../assets/img/tech icons/bootstrab.webp" id="bootstrab" alt="bootstrab">
                                <b-tooltip target="bootstrab" custom-class="bootstrab">Bootstrap</b-tooltip>
                            </div>
                            <div class="grid-item">
                                <img src="../assets/img/tech icons/vue.webp" id="vue" alt="vue">
                                <b-tooltip target="vue" custom-class="vue">VueJs</b-tooltip>
                            </div>
                            <div class="grid-item">
                                <img src="../assets/img/tech icons/react.webp" id="react" alt="react">
                                <b-tooltip target="react" custom-class="react">ReactJs</b-tooltip>
                            </div>
                            <div class="grid-item">
                                <img src="../assets/img/tech icons/css.webp" id="css" alt="css">
                                <b-tooltip target="css" custom-class="css">Css</b-tooltip>
                            </div>
                            <div class="grid-item">
                                <img src="../assets/img/tech icons/html.webp" id="html" alt="html">
                                <b-tooltip target="html" custom-class="html">Html</b-tooltip>
                            </div>
                            <div class="grid-item">
                                <img src="../assets/img/tech icons/js.webp" id="js" alt="js">
                                <b-tooltip target="js" custom-class="js">JavaScript</b-tooltip>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <img src="../assets/img/dots2.webp" class="line" alt="Background image">
    </section>
</template>

<script>
export default {
    name: "Tech",
    data() {
        return {
            lang: '',
        };
    },
    methods: {

    },
};
</script>

<style lang="scss">
.tech {
    padding: 80px 0px;
    // background-color: rgba(231, 231, 231, 0.356);
    position: relative;
}
.tech .tect-icons{
    z-index: 100;
    position: inherit;
}
.tech .line {
    position: absolute;
    top: 0;
    left: 0;
    width: 40%;
}

.tect-icons img {
    width: 40%;
    transition: all .4s;
}

.tect-icons img:hover {
    cursor: pointer;
    transform: scale(1.1, 1.1);
    transition: all .4s;
}

.laravel .tooltip-inner {
    background: #ff291a !important;
}

.laravel.bs-tooltip-top .arrow::before {
    border-top-color: #ff291a !important;
}

.flutter2 .tooltip-inner {
    background: #66b5f5 !important;
}

.flutter2.bs-tooltip-top .arrow::before {
    border-top-color: #66b5f5 !important;
}

.mysql .tooltip-inner {
    background: #00758f !important;
}

.mysql.bs-tooltip-top .arrow::before {
    border-top-color: #00758f !important;
}


.bootstrab .tooltip-inner {
    background: #5e3b7f !important;
}

.bootstrab.bs-tooltip-top .arrow::before {
    border-top-color: #5e3b7f !important;
}


.vue .tooltip-inner {
    background: #3fb984 !important;
}

.vue.bs-tooltip-top .arrow::before {
    border-top-color: #3fb984 !important;
}


.react .tooltip-inner {
    background: #00d8ff !important;
}

.react.bs-tooltip-top .arrow::before {
    border-top-color: #00d8ff !important;
}


.html .tooltip-inner {
    background: #e44d26 !important;
}

.html.bs-tooltip-top .arrow::before {
    border-top-color: #e44d26 !important;
}

.css .tooltip-inner {
    background: #0277bd !important;
}

.css.bs-tooltip-top .arrow::before {
    border-top-color: #0277bd !important;
}

.js .tooltip-inner {
    background: #d6ba32 !important;
}

.js.bs-tooltip-top .arrow::before {
    border-top-color: #d6ba32 !important;
}

.tech .flutter {
    width: 50% !important;
}

.tech .main-title {
    text-align: center;
    font-size: 65px;
    font-weight: bold;
    color: var(--main-blue);
    // margin-bottom: 60px;
}

.tech .tech-disc {
    color: var(--main-blue);
    text-align: center;
    font-size: 20px;
    margin-top: 20px
}

.tech .grid-container {
    display: grid;
    grid-template-columns: repeat(3, auto);
    align-items: center;
    row-gap: 50px;
}

.tech .grid-item {
    text-align: center;
}


html:lang(en) .tech .left .before-enter {
    opacity: 0;
    transform: translateX(-15px);
    transition: all 1s ease;
}

html:lang(ar) .tech .left .before-enter {
    opacity: 0;
    transform: translateX(15px);
    transition: all 1s ease;
}

html:lang(ar) .tech .left .enter,
html:lang(en) .tech .left .enter {
    opacity: 1;
    transform: translateX(0px);
}

html:lang(en) .tech .right .before-enter {
    opacity: 0;
    transform: translateX(15px);
    transition: all 1s ease;
}

html:lang(ar) .tech .right .before-enter {
    opacity: 0;
    transform: translateX(-15px);
    transition: all 1s ease;
}

html:lang(ar) .tech .right .enter,
html:lang(en) .tech .right .enter {
    opacity: 1;
    transform: translateX(0px);
}


@media (max-width: 991px) {
    .tech .left {
        margin-bottom: 40px;
    }

    .tech .line {
        display: none;
    }

    .tech .main-title {
        font-size: 35px;
    }

    .tech .tech-disc {
        font-size: 20px;
    }

    // .tect-icons img {
    //     width: 20%;
    // }

    .tech .flutter {
        width: 58% !important;
    }

}</style>